import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { observable, runInAction } from "mobx";
class TcfPurpose {
    constructor(data, special, store){
        runInAction(()=>{
            this.special = special;
            this.data = data;
        });
        this.store = store;
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], TcfPurpose.prototype, "data", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Boolean)
], TcfPurpose.prototype, "special", void 0);
export { TcfPurpose };
